<div class="filters">
  <span class="label">Status</span>
  <button [class.on]="!status" (click)="setStatus('')">All</button>
  <button *ngFor="let s of statuses" [class.on]="status === s" (click)="setStatus(s)">{{ s.replace('_', ' ') }}</button>
</div>
<div class="filters type-filters">
  <span class="label">Type</span>
  <button [class.on]="!type" (click)="setType('')">All</button>
  <button *ngFor="let t of types" [class.on]="type === t" (click)="setType(t)">{{ t }}</button>
</div>

<div class="loading" *ngIf="loading"><mat-spinner diameter="28"></mat-spinner></div>
<div class="notice bad" *ngIf="error">{{ error }}</div>
<p class="empty" *ngIf="!loading && !error && !rows.length">Nothing recorded with these filters.</p>

<div class="panel intel" *ngFor="let r of rows" [class.overdue]="isOverdue(r.item)">
  <div class="row top">
    <span class="pill tag">{{ r.item.type }}</span>
    <span class="pill rejected" *ngIf="isOverdue(r.item)">Overdue</span>
    <span class="pill pending" *ngIf="r.item.status === 'new'">New</span>
    <app-person-link *ngIf="r.item.userId" [uid]="r.item.userId" [name]="r.item.memberName"></app-person-link>
    <a class="event-link" *ngIf="r.item.conversationId"
      [routerLink]="['/admin/people/outreach/conversations', r.item.conversationId]">conversation #{{ r.item.conversationId }}</a>
    <span class="muted">#{{ r.item.id }} · {{ r.item.createdAt | date: 'd MMM' }} · confidence
      {{ r.item.confidence | percent: '1.0-0' }}</span>
  </div>
  <div class="summary text">{{ r.item.summary }}</div>
  <div class="quote">“{{ r.item.quote }}”</div>
  <div class="row edit">
    <select class="input" [ngModel]="r.item.status" (ngModelChange)="saveStatus(r, $event)" [disabled]="r.saving"
      aria-label="Status">
      <option *ngFor="let s of statuses" [value]="s">{{ s.replace('_', ' ') }}</option>
    </select>
    <input class="input" [(ngModel)]="r.owner" (blur)="saveOwner(r)" (keydown.enter)="saveOwner(r)"
      placeholder="Owner" aria-label="Owner" maxlength="200" />
    <input class="input" type="date" [(ngModel)]="r.due" (change)="saveDue(r)" aria-label="Due date" />
    <button mat-stroked-button (click)="propose(r.item)">Propose next step</button>
    <span class="muted" *ngIf="r.saving">Saving…</span>
  </div>
  <textarea class="input notes" rows="2" [(ngModel)]="r.notes" (blur)="saveNotes(r)" placeholder="Notes"
    aria-label="Notes" maxlength="4000"></textarea>
  <p class="problems" *ngIf="r.error">{{ r.error }}</p>
</div>
